// import angular from 'angular';
import API_RESOURCES from '../../../constants/api.constants.js';

export const BASE_PATH = `${API_RESOURCES.API_UI_URL}/`;

export default class DataAccessObject {

	constructor($resource, appNotificationsInterceptor, config) {

		this.$resource = $resource;
		this.appNotificationsInterceptor = appNotificationsInterceptor;


		this.setDefaults(config.defaults);

		this.customActions = {
			update: {
				method: 'PATCH',
				notifications: true
			},
			delete: {
				method: 'DELETE',
				notifications: true
			},
			fetch: {
				method: 'POST'
			},
			create: {
				method: 'POST',
				notifications: true
			}
		};

		this.url = config.pathIsAbsolute ? config.path : BASE_PATH + config.path;

		this.setCustomActions(config.customActions);
		this.setParamsDefaults(config.paramDefaults);

		this.extendPrototype = config.extendPrototype;
	}

	get Resource() {
		let result = this.$resource(this.url, this.paramsDefaults, this.customActions);
		if (this.extendPrototype) {
			angular.extend(result.prototype, this.extendPrototype);
		}
        let cancellableRequests = {};

		Object.keys(result).forEach((action) => {
			if(this.customActions[action]) {
				result[action].setHeaders = (key, value) => {
					this.customActions[action].headers = {[key]: value};
				};
				result[action].removeHeaders = () => {
					this.customActions[action].headers = null;
				};
			}
			if (this.customActions[action] && this.customActions[action].cancellable) {
                let origMethod = result[action];
                result[action] = (...params) => {
                    let res = origMethod(...params);
                    if (!cancellableRequests[action]) cancellableRequests[action] = [];
                    cancellableRequests[action].push(res);
                    return res;
                };
                if (!result.$cancelAll) {
                    result.$cancelAll = (methodName) => {
                        if (cancellableRequests[methodName]) {
                            cancellableRequests[methodName].forEach(request => {
                                if (request.$cancelRequest) request.$cancelRequest();
                            });
                            cancellableRequests[methodName] = [];
                        }
                    }
                }
            }
		});

		this.resource = result;
		return this.resource;
	}

	get Url() {
		return this.url;
	}

	setDefaults(options) {
		this.defaults = this.defaults || {};
		angular.extend(this.defaults, options);
	}

	setCustomActions(actionsObject) {
		this.customActions = this.customActions || {};
		if(!actionsObject) {
			return;
		}

		Object.keys(actionsObject).forEach((action) => {
			let actionParams = actionsObject[action];
			if (actionParams.url) {
				actionParams.url = BASE_PATH + actionParams.url;
			}

			if (angular.isDefined(actionParams.notifications) && actionParams.notifications) {
				if (actionParams.notifications) {
					actionParams.interceptor = this.appNotificationsInterceptor;
				}
			}

			if (this.customActions[action]) {
				angular.extend(this.customActions[action], actionParams);
			} else {
				this.customActions[action] = angular.copy(actionParams);
			}
		});
	}

	setParamsDefaults(paramDefaults) {
		this.paramsDefaults = paramDefaults;
	}

	extendPrototype(prototype) {
		this.extendPrototype = prototype;
		return this;
	}

	transformResponse(callback) {
		this.transformResponse = callback;
		return this;
	}
}




// WEBPACK FOOTER //
// ./modules/distribution/core/DAL/DAO/DataAccessObject.js